<template>
    <div class="container">
        <vue-headful
                title="Memberships - SIC Dashboard"
        />
        <div class="row">
            <div class="col-md-12 mt-5 mb-5">
                <div class="card shadow">
                    <div class="card-header border-0">
                        <div class="row align-items-center">
                            <div class="col">
                                <div class="row">
                                    <div class="m-2" @click="get_Memberships('companies')">
                                        <base-button>Companies</base-button>
                                    </div>
                                    <div class="m-2" @click="get_Memberships('students')">
                                        <base-button>Universities</base-button>
                                    </div>
                                    <div class="m-2" @click="get_Memberships('employees')">
                                        <base-button>Employees</base-button>
                                    </div>
                                </div>
                            </div>
                            <div class="">
                                <button @click="goNew()" type="button" class="btn my-4 btn-primary">
                                    ADD Memberships
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <!-- Projects table -->
                        <table class="table align-items-center table-flush">
                            <thead class="thead-light">
                            <tr>
                                <th>Actions</th>
                                <th scope="col">User ID</th>
                                <th scope="col">User Type</th>
                                <th scope="col">Title</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="membership in MembershipsDetails" :key="membership.id">
                                <td>
                                    <button @click="deleteMembership(membership.id)" type="button"
                                            class="btn btn-danger fas fa-trash" data-toggle="tooltip"
                                            data-placement="top" title="Delete Idea"></button>
                                    <button @click="editMembership(membership.id)" type="button" class="btn btn-info fas fa-pen"
                                            data-toggle="tooltip" data-placement="top" title="Edit Idea"></button>
                                </td>
                                <td scope="row">
                                    <strong>{{membership.user_id}}</strong>
                                </td>
                                <td>
                                    {{membership.user_type}}
                                </td>
                                <td v-html="membership.title">
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from "lodash";
import axios from "axios";
import vueHeadful from "vue-headful";

export default {
  data() {
    return {
      MembershipsDetails: {}
    };
  },
  methods: {
    wip: function() {
      alert("Work in progress");
    },
    goNew: function() {
      window.location.href = "/dashboard/website/memberships/new";
    },
    editMembership: function(membership_id) {
      window.location.href =
        "/dashboard/website/memberships/update/" + membership_id;
    },
    get_Memberships(type) {
      axios({
        url:
          "admin/memberships/" +
          type +
          "?access_token=" +
          localStorage.getItem("access_token"),
        method: "get",
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.MembershipsDetails = result.data.memberships.data;
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    deleteMembership(id) {
      axios({
        method: "delete",
        url: "admin/memberships/delete/" + id,
        data: {
          access_token: localStorage.getItem("access_token")
        },
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.$swal("Membership Deleted Successfully", "", "success");
            this.get_Memberships("companies");
            result;
          },
          error => {
            this.$swal(
              "Error",
              "There was an error. Please try again",
              "error"
            );
            let errors = error.response.data.error;
            for (let error in errors) {
              this.$noty.error("Error: " + _.startCase(errors[error][0]));
            }
          }
        )
        .catch(e => {
          console.log(e);
        });
    }
  },
  computed: {},
  components: {
    "vue-headful": vueHeadful
  },
  mounted: function() {
    this.get_Memberships("companies");
  }
};
</script>
<style>
</style>
